import { GasQuality, PressureStage } from "../../../types/api.types";
import type { FormInputData } from "../../BuildingBlocks/Forms/Controllers/FormFieldController";
import type { GasConnectionUpdateRequest } from "../GasConnection.types";

export const GAS_CONNECTION_FORM_FIELD_DATA = {
  name: {
    name: "name",
    label: "Bezeichnung",
    type: "text",
    required: true,
    helpText: "Frei wählbar, wird nur zur Identifikation verwendet"
  },
  pressure_stage: {
    name: "pressure_stage",
    label: "Druckstufe",
    type: "select",
    required: true,
    data: [
      { label: "Niederdruck", value: PressureStage.Low },
      { label: "Mitteldruck", value: PressureStage.Medium },
      { label: "Hochdruck", value: PressureStage.High }
    ]
  },
  gas_quality: {
    name: "gas_quality",
    label: "Gasqualität",
    type: "select",
    required: true,
    data: [
      { label: "L-Gas", value: GasQuality.Low },
      { label: "H-Gas", value: GasQuality.High }
    ]
  },
  connecting_party: {
    name: "connecting_party",
    label: "Netzanschlussnehmer",
    type: "select",
    required: false,
    helpText:
      "\nDer Netzanschlussnehmer hält den Netzanschlussvertrag mit dem Netzbetreiber.\nIn der Regel ist der Netzanschlussnehmer der Eigentümer der Liegenschaft, die an das Netz der allgemeinen Versorgung angeschlossen ist.\n",
    data: [] // will be set at runtime
  }
} as const satisfies {
  [key in keyof GasConnectionUpdateRequest]?: FormInputData<
    GasConnectionUpdateRequest,
    key
  >;
};
